import http from '@/http'

export type MarkGiftResponse = {
  ok: boolean
  message?: string
  hasGift?: boolean
  eligible?: boolean
}

/**
 * Modo "Brinde" — RETIRADA. Registra (ou desfaz) a retirada do brinde. A tag do
 * brinde é a ELEGIBILIDADE e NÃO é tocada aqui: entregar exige que o participante
 * já tenha a tag (senão o back devolve 422 com eligible=false — autorize antes via
 * grantGift). Desfazer mantém a tag (só reverte a retirada). É registro/histórico,
 * não presença.
 */
export async function markGift (id: number | string, tagId: number, remove = false): Promise<MarkGiftResponse> {
  const response = await http.post(`/admin/check-in/participants/${id}/gift`, {
    tag_id: tagId,
    remove
  }, {
    validateStatus: () => true
  })

  return {
    ok: response.status === 200,
    message: response.data && response.data.message,
    hasGift: response.data && response.data.has_gift,
    eligible: response.data && response.data.eligible
  }
}

export type GrantGiftResponse = {
  ok: boolean
  message?: string
  eligible?: boolean
}

/**
 * Modo "Brinde" — ELEGIBILIDADE. Concede (grant=true) ou revoga (grant=false) a
 * tag do brinde para o participante — é a autorização que habilita a retirada.
 * Estilo "Detalhes → Tags", porém para UMA tag só. Brinde é individual: não
 * propaga para acompanhantes.
 */
export async function grantGift (id: number | string, tagId: number, grant = true): Promise<GrantGiftResponse> {
  const response = await http.post(`/admin/check-in/participants/${id}/gift-eligibility`, {
    tag_id: tagId,
    grant
  }, {
    validateStatus: () => true
  })

  return {
    ok: response.status === 200,
    message: response.data && response.data.message,
    eligible: response.data && response.data.eligible
  }
}
